import { DotsThreeVertical } from "@phosphor-icons/react";
import { useMemo } from "react";

import DesktopActions from "common/components/DesktopActions";
import SimpleDataTable from "common/components/SimpleDataTable";
import { Button } from "common/components/ui/Button";

import { WEBHOOKS_ACTIONS } from "../../../constants";
import WebhookActions from "../WebhookActions";

import type { ColumnDef } from "@tanstack/react-table";
import type { Webhook } from "../../../types";

interface TableProps {
  webhooks: Webhook[];
}

export default function WebhooksDesktopTable({ webhooks }: TableProps) {
  const columns = useMemo<ColumnDef<Webhook>[]>(
    () => [
      {
        id: "name",
        header: "Webhook name",
        cell: ({ row }) => (
          <span className="text-md-bold">{row.original.name}</span>
        ),
      },
      {
        id: "url",
        header: "URL",
        cell: ({ row }) => row.original.url,
      },
      {
        id: "event",
        header: "Event",
        cell: ({ row }) => {
          const { events } = row.original;

          return events.length === 1
            ? events[0]
            : `${events[0]} (+ ${events.length - 1} more)`;
        },
      },
      {
        id: "actions",
        header: "",
        cell: ({ row }) => (
          <DesktopActions
            triggerElement={
              <Button intent="iconOnly" variant="secondary-black" size="sm">
                <DotsThreeVertical />
              </Button>
            }
            editOptions={WEBHOOKS_ACTIONS}
            getDialogSize={(action) => (action === "delete" ? "md" : "lg")}
          >
            {(action, onClose) => (
              <WebhookActions
                action={action}
                webhook={row.original}
                onClose={onClose}
                onBack={onClose}
              />
            )}
          </DesktopActions>
        ),
      },
    ],
    [],
  );

  return (
    <SimpleDataTable
      columns={columns}
      data={webhooks}
      localStorageId="webhooks"
    />
  );
}
